<template>
  <div class="text-center">

 
    <v-dialog
      v-model="dialog"
      width="500"
    >


    <div class="my-2">
      <v-btn @click="dialogData = true">check data</v-btn>
    </div>

     <v-dialog
      v-model="dialogData"
    >
      <v-card>


        <v-card-title>OPCION
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialogData = false">CLOSE</v-btn>
        </v-card-title>
          <v-card-text class="pprint">{{usuario2}}</v-card-text>

       
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialogData = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
 

      <template v-slot:activator="{ on, attrs }">
       
       <v-btn 
       v-bind="attrs"
          v-on="on"
          icon
          data-cy="add-usuario-input"
       @click="usuarioEditIcon" 
       >
        LOGIN WITH GOOGLE DIALOG
       <!-- <v-icon left>mdi-monitor-edit</v-icon></v-btn> 
         style="width: 100%; height: 500px; border: none;" -->
       -->

 <v-icon left>mdi-square-edit-outline</v-icon></v-btn>
       
       
      </template>










      <v-card>
      <v-card-title class="headline">Login with Google</v-card-title>
      <v-card-text>

        <template>
        <iframe
        id="miIframe"
        name="example"
          v-if="iframeSrc"
          

         
         :src="iframeSrc"

         style="width: 100%; height: 500px; border: none;"
          
        >


               
        
     
        
        
        </iframe>

           </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>





      <v-card>
      

        <v-card-text>
         
          <v-container>
    <v-row>

        <v-col cols="12">
          <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >

    
  
      <v-col cols="12">


       



             
   


      </v-col>

    <v-col
        cols="12"
        md="12"
      >

      <v-text-field
           v-model="usuario.descripcion"
           label="Descripcion"
           :counter="2"
           :rules="textRules"
           disabled
         ></v-text-field>

          

   
 <v-text-field
           v-model="usuario.link"
           label="Link"
           disabled
         ></v-text-field>




       
      </v-col>

      <v-divider></v-divider>

        <v-card-actions>

            <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="loginWithGoogle"
      >
        Login with Google
      </v-btn>

       <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="loginWithGoogleCal"
      >
        Login with Google Cal
      </v-btn>

        <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="obtener"
      >
        Obtener Google
      </v-btn> 

     

          <v-spacer></v-spacer>
           <v-btn
        color="error"
        class="mr-4"
        @click="cancelar"
      >
        Cancelar
      </v-btn>
        </v-card-actions>

      
    </v-form> 

        </v-col>
    </v-row>
  </v-container>

        </v-card-text>

        
      </v-card>
    </v-dialog>
  </div>
</template>


<script>




import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import loginService from "@/services/loginService.js";
import { http } from "@/services/config";


  export default {
    name:"UsuarioIcon",
    

     props: {
    usuarioData: {
      type: Object, 
      default: () => ({}) 
    },
    principalData: {
      type: Object, 
      default: () => ({}) 
    }

  },

    data: () => ({
      iframeSrc: '',
 dialogData: false,
 buscador:'',
        imagenesBases: [],
        imagenesBase:{
id:'',
descripcion:'',
tipo:'',
linkPhoto:'',
icon:''
        },


       zoom: 50,
      archivo: null,
      fileData: {
        url: "",
        name:""
      },
       server_url: "",
        usuario2:{
      
        }
       ,
       usuario:{

descripcion:'',
link:'',
linkPhoto:'',
tipo:'',
observacion:'',
id:'',
color:'#1F7087',
icon:'mdi-instagram',
principal:{}

          
        }
    ,
       valid: false,
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
      dialog:false,
    }),
  created(){

       }
  ,mounted(){

  Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });

     this.server_url = http.defaults.baseURL;

    
      //  this.loginWithGoogle();

       window.addEventListener('message', function(event) {
            if (event.origin === 'http://127.0.0.1:8000') {
                const data = event.data;
                
                if (data) {
                    localStorage.setItem('message', data.message);
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('token_type', data.token_type);
                    localStorage.setItem('user', JSON.stringify(data.user));
                    localStorage.setItem('roles', JSON.stringify(data.roles));
                    localStorage.setItem('roles_permissions', JSON.stringify(data.roles_permissions));
                    localStorage.setItem('permissions', JSON.stringify(data.permissions));
                    localStorage.setItem('identificador', data.identificador);
                    console.log('Data stored in localStorage: funciono interno mouted', data);

                    this.usuario2 =data.user;

                    console.log(this.usuario2.identificador)
                   // this.usuario.token=data.token;

                    console.log(data.user.oauth_id);

                      localStorage.setItem('tokenIdentificador', this.usuario2.identificador);

                } else {
                    console.log('No data received.');
                }
            } else {
                console.log('Origin not allowed:', event.origin);
            }
        });

         

    },

    methods:{
      cancelar(){
             this.$emit("usuarioEdit", this.usuario2);
                  this.dialog = false;



      },
      onMessageFromIframe(event) {

        console.log('Ingreseeeeeeeeeee');
      // Verificar si el mensaje proviene del origen esperado para seguridad
      if (event.origin !== 'http://127.0.0.1:8000') {
        return;
      }
      
      // El contenido del mensaje es event.data, que se espera que sea un JSON
      const receivedData = JSON.parse(event.data);
      console.log('Mensaje recibido desde el iframe:', receivedData);
    },

      onIframeLoad() {
      const iframe = this.$refs.iframe;
      if (iframe && iframe.contentWindow) {
        try {
          const iframeContent = iframe.contentWindow.document.body.textContent || iframe.contentWindow.document.body.innerText;
          const jsonObject = JSON.parse(iframeContent);
          localStorage.setItem('jsonObject', JSON.stringify(jsonObject));
          console.log('JSON almacenado en el local storage:', jsonObject);
        } catch (error) {
          console.error('Error al acceder o almacenar el contenido del iframe:', error);
        }
      }
    },



    seleccionarUsuarioIcon(imagenesBase) {
      console.log("Seleccionado paso 1 "+imagenesBase);

   

   //   this.$emit("usuarioEditIcon", imagenesBase);
   //  this.dialog = false;
    },


      loginWithGoogle() {

    this.iframeSrc = 'http://127.0.0.1:8000/api/login/google';

    console.log("Luego de cargar");

      this.dialog = true;

     // window.addEventListener('message', this.receiveMessage);


    //console.log(message);

//window.parent.postMessage(jsonResponse, "*");

  //   window.location.href = 'http://127.0.0.1:8000/api/login/google';
  
  },

   loginWithGoogleCal() {

     loginService.autenticarGoogleCal().then((resp) => {

                    console.log("Autenticación por Google");
                  console.log(resp.data);
                  

                })
  },

  obtener(){
   /* const iframe = document.getElementById('miIframe');
      if (iframe) {
        const iframeContent = iframe.contentDocument || iframe.contentWindow.document;
        console.log('Contenido del iframe:', iframeContent);
      }*/

     window.addEventListener('message', function(event) {
            if (event.origin === 'http://127.0.0.1:8000') {
                const data = event.data;
                
                if (data) {
                    localStorage.setItem('message', data.message);
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('token_type', data.token_type);
                    localStorage.setItem('user', JSON.stringify(data.user));
                    localStorage.setItem('roles', JSON.stringify(data.roles));
                    localStorage.setItem('roles_permissions', JSON.stringify(data.roles_permissions));
                    localStorage.setItem('permissions', JSON.stringify(data.permissions));
                    localStorage.setItem('identificador', data.identificador);
                    console.log('Data stored in localStorage:', data);
                } else {
                    console.log('No data received.');
                }
            } else {
                console.log('Origin not allowed:', event.origin);
            }
        });

  },
    receiveMessage(event) {
      // Aquí puedes verificar el origen del mensaje para mayor seguridad
      if (event.origin !== 'http://127.0.0.1:8000') {
        return;
      }

      // Obtener los datos del mensaje
      const data = event.data;
      this.token = data.token;
      this.user = data.user;

      console.log('Token:', this.token);
      console.log('Usuario:', this.user);

      // Cerrar el diálogo si es necesario
      this.dialog = false;

      // Quitar el listener después de recibir el mensaje
      window.removeEventListener('message', this.receiveMessage);
    
  },

     usuarioEditIcon(imagenesBase){
       console.log("Ingrese al pulsar el boton de abrir icono nro (1) 2 ");
           this.usuario=this.usuarioData;
      console.log(imagenesBase);

    },
    
    colorEdit(){
      console.log(this.color);
    },
    registrarUsuario(){

            if (this.$refs.form.validate()) {
        
        }

    }
        ,
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.usuario={
				nombre:'',
        apellido:'',
				linkPhoto:'',
				descripcion:'',
				observacion:'',
				id:'',
	}
    },

    },

    computed: {

     
    
      
      
    },
  watch: {
    
  }
  }
</script>